import { Box, Center, Flex, Spinner, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react'
import VariableApi from './TestMessage/VariableApi.js'

import Header from '../components/Header.js'
import { hasPermission } from '../utils/DefaultFunction.js'
import { useLocation } from 'react-router-dom'
import API from '../helpers/axiosInstance.js'
import ParserApi from './TestMessage/ParserApi.js'
import BoxWrapper from '../components/BoxWrapper/BoxWrapper.jsx'
import SubscriberAPI from './TestMessage/SubscriberAPI.jsx'
import FlowApi from './TestMessage/FlowApi.js'
import EmailApi from './TestMessage/EmailApi.js'
const getApiHeaders = () => ({
	'x-api-key': localStorage.getItem('api-key'),
	'x-access-token': localStorage.getItem('customer-portal'),
});

const SendMessage = ({ header }) => {
	const location = useLocation();
	const [permissions, setPermissions] = useState([]);
	const [loading, setLoading] = useState(false);

	const params = location.pathname.replace('/', "")

	const fetchPermissions = async () => {
		setLoading(true);
		try {
			const url = `${process.env.REACT_APP_API_URL}/permission/feature/list?slug=${params}`;
			const response = await API.get(url, { headers: getApiHeaders() });

			setPermissions(response.data.data || []);
		} catch (error) {
			console.error("Error fetching permissions:", error);
			setPermissions([]);
		} finally {
			setLoading(false);
		}
	};
	useEffect(() => {
		fetchPermissions();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const sendPermission = hasPermission("send-msg-variable", permissions)

	// Shared width for the pill tab bar and every card below it, so they
	// always end at exactly the same edge.
	const CONTENT_WIDTH = "800px";

	if (loading) {
		return (
			<>
				<Header />
				<BoxWrapper >
					<Flex justify="center" align="center" h="300px">
						<Spinner size="lg" />
					</Flex>
				</BoxWrapper>
			</>
		);
	}
	return (
		<div>
			<Header header={header} />
			<BoxWrapper>
				{sendPermission ? <Box>
					<Box mb={5}>
						<Text fontSize="lg" fontWeight="600" color="gray.800">Send Test Message</Text>
						<Text fontSize="sm" color="gray.500" mt={1}>
							Try each messaging API directly — pick a method below and send a real test message.
						</Text>
					</Box>
					<Tabs variant="unstyled" isLazy>
						<TabList bg="#f1f5f9" p="1" borderRadius="full" gap={1} w={CONTENT_WIDTH} maxW="100%" overflowX="auto" overflowY="hidden">
							{['Variable API', 'Passthrough API', 'Mobile Subscriber API', 'Send Flow API', 'Send Test Email'].map((label) => (
								<Tab
									key={label}
									flex={1}
									px={4}
									py={1.5}
									borderRadius="full"
									fontSize="sm"
									fontWeight="500"
									color="gray.500"
									whiteSpace="nowrap"
									transition="all 0.15s"
									_hover={{ color: 'gray.700' }}
									_selected={{ bg: 'white', color: 'gray.800', fontWeight: '600', boxShadow: 'sm' }}
								>
									{label}
								</Tab>
							))}
						</TabList>

						<TabPanels>
							<TabPanel px={0} pt={5}>
								<Box className="box-style-card" w={CONTENT_WIDTH} maxW="100%" bg="white">
									<VariableApi />
								</Box>
							</TabPanel>
							<TabPanel px={0} pt={5}>
								<Box className="box-style-card" w={CONTENT_WIDTH} maxW="100%" bg="white">
									<ParserApi />
								</Box>
							</TabPanel>
							<TabPanel px={0} pt={5}>
								<Box className="box-style-card" w={CONTENT_WIDTH} maxW="100%" bg="white">
									<SubscriberAPI />
								</Box>
							</TabPanel>
							<TabPanel px={0} pt={5}>
								<Box className="box-style-card" w={CONTENT_WIDTH} maxW="100%" bg="white">
									<FlowApi />
								</Box>
							</TabPanel>
							<TabPanel px={0} pt={5}>
								<Box className="box-style-card" w={CONTENT_WIDTH} maxW="100%" bg="white">
									<EmailApi />
								</Box>
							</TabPanel>

						</TabPanels>
					</Tabs>
				</Box> : <BoxWrapper >
					<Center h="400px">
						<Box textAlign="center">
							<Text fontSize="xl" fontWeight="semibold" color="gray.700" mb={2}>
								No Access
							</Text>
							<Text fontSize="sm" color="gray.500">
								You don't have permission to view this sections.
							</Text>
						</Box>
					</Center>
				</BoxWrapper>}

			</BoxWrapper>
		</div>
	)
}

export default SendMessage